import { Link } from "react-router";
import { Icon } from "@shared/components/Icon.tsx";
import { GROUPS } from "@shared/lib/enums.ts";
import { formatDateMr } from "@shared/lib/format.ts";
import { COMPETITION } from "../content/competition.ts";
import { IMAGES } from "../content/images.ts";
import { Gallery } from "../components/ImageSlot.tsx";

const TBA = "लवकरच जाहीर होईल";
const GROUP_EMOJI: Record<string, string> = { school: "🎒", open: "🎓" };

export function HomePage() {
  const facts = [
    {
      label: "नोंदणीची अंतिम तारीख",
      value: COMPETITION.registrationCloses
        ? formatDateMr(COMPETITION.registrationCloses)
        : TBA,
    },
    { label: "नोंदणी शुल्क", value: "निःशुल्क", free: true },
  ];
  return (
    <>
      {/* Hero banner — background image set in public.css's .hero rule (static/images/shivaji_maharaj.jpeg) */}
      <section className="page-banner hero">
        <div className="container">
          <div className="hero__content">
            <p className="hero__eyebrow">
              छत्रपती सेवा प्रतिष्ठान, नागपूर-पुणे पुरस्कृत
            </p>
            <h1 className="hero__title">
              <span className="hero__title-line">
                {COMPETITION.homeTitleLine1}
              </span>
              <span className="hero__title-line hero__title-line--gold">
                {COMPETITION.homeTitleLine2} {COMPETITION.season}
              </span>
            </h1>
            <p className="hero__lede">{COMPETITION.tagline}</p>
            <div className="hero__actions">
              <Link to="/register" className="btn btn-lg btn-hero">
                आता नोंदणी करा →
              </Link>
              <Link to="/rules" className="btn btn-lg btn-hero-outline">
                माहिती, नियम आणि अटी वाचा
              </Link>
            </div>
          </div>
        </div>
      </section>

      <div className="container content">
        <dl className="facts">
          {facts.map((f) => (
            <div key={f.label} className="fact">
              <dt>{f.label}</dt>
              <dd
                className={
                  f.value === TBA ? "is-tba" : "free" in f ? "is-free" : ""
                }
              >
                {f.value}
              </dd>
            </div>
          ))}
        </dl>

        <section className="section">
          <h2 className="section-title">सहभागासाठी दोन गट</h2>
          <div className="group-grid">
            {GROUPS.map((g) => (
              <article
                key={g.value}
                className="category-card is-static group-card"
              >
                <div className="category-card__icon" aria-hidden="true">
                  {GROUP_EMOJI[g.value]}
                </div>
                <div className="category-card__title">{g.label}</div>
                <div className="category-card__desc">{g.desc}</div>
              </article>
            ))}
          </div>
        </section>

        <Gallery photos={IMAGES.homeGallery} title="क्षणचित्रे" />

        <section className="section">
          <h2 className="section-title">नोंदणी कशी करावी</h2>
          <ol className="progress progress--static">
            <li>माहिती, नियम आणि अटी पुर्ण वाचुन मान्य करुन संमती द्या</li>
            <li>आपला गट निवडा</li>
            <li>माहिती भरा</li>
            <li>माहिती तपासून नोंदणी पूर्ण करा</li>
          </ol>
          <div className="alert alert-info" style={{ marginTop: 8 }}>
            <Icon name="info" size={20} />
            <div className="alert-body">
              नोंदणी <strong>पूर्णपणे निःशुल्क</strong> आहे. नोंदणी पूर्ण
              झाल्यावर आपल्याला <strong>नोंदणी ID</strong> मिळेल. तो लिहून ठेवा
              किंवा screenshot घ्या — पुढील सर्व पत्रव्यवहारासाठी तो आवश्यक आहे.
              आयडी विसरल्यास <Link to="/find-id">येथे शोधा</Link>.
            </div>
          </div>
          <div className="center" style={{ marginTop: 28 }}>
            <Link to="/register" className="btn btn-primary btn-lg">
              नोंदणी सुरू करा →
            </Link>
          </div>
        </section>
      </div>
    </>
  );
}
